export const MIN_ITEM_WIDTH = 20;
export const MIN_WIDTH_TO_SHOW_DATES = 96;
// Right inset matching the WeekHeader pill's pr-2 so items align with their date pill.
export const ITEM_RIGHT_INSET = 8;
export const ITEM_LANE_HEIGHT = 68;
export const ITEM_LANE_HEIGHT_COMPACT = 40;
// Capsule height is uniform whether or not the item shows a badge/label.
export const ITEM_HEIGHT = 54;
export const ITEM_HEIGHT_COMPACT = 30;
export const ITEM_TOOLTIP_DELAY = 300;
// Grace period before closing so transit between the bar and the tooltip
// (or first-open content reflow) doesn't dismiss it.
export const TOOLTIP_CLOSE_DELAY = 120;
export const STALE_TIME_MS = 60 * 60 * 1000;
